// extracted by mini-css-extract-plugin
export var divider = "_1y-0";
export var dividerText = "_1y-2";
export var dividerVertical = "_1y-1";